import api from './api';

const photoService = {
  // Upload d'une photo
  uploadPhoto: async (contractId, file, description = '', isPrimary = false) => {
    try {
      const formData = new FormData();
      formData.append('photo', file);
      formData.append('description', description);
      formData.append('isPrimary', isPrimary.toString());

      const response = await api.post(`/contracts/${contractId}/photos`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('Erreur upload photo:', error);
      return {
        success: false,
        error: error.response?.data?.error || 'Erreur lors de l\'upload de la photo'
      };
    }
  },

  // Suppression d'une photo
  deletePhoto: async (contractId, photoId) => {
    try {
      const response = await api.delete(`/contracts/${contractId}/photos/${photoId}`);
      
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('Erreur suppression photo:', error);
      return {
        success: false,
        error: error.response?.data?.error || 'Erreur lors de la suppression de la photo'
      };
    }
  },

  // Définir une photo comme principale
  setPrimaryPhoto: async (contractId, photoId) => {
    try {
      const response = await api.put(`/contracts/${contractId}/photos/${photoId}/primary`);
      
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('Erreur définition photo principale:', error);
      return {
        success: false,
        error: error.response?.data?.error || 'Erreur lors de la définition de la photo principale'
      };
    }
  },

  // Mettre à jour la description ou la rotation d'une photo
  updatePhotoDetails: async (contractId, photoId, data) => {
    try {
      const response = await api.put(`/contracts/${contractId}/photos/${photoId}`, data);
      
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('Erreur mise à jour description:', error);
      return {
        success: false,
        error: error.response?.data?.error || 'Erreur lors de la mise à jour de la description'
      };
    }
  },

  // Validation d'un fichier image
  validateImageFile: (file) => {
    const errors = [];

    // Vérifier le type
    if (!file.type.startsWith('image/')) {
      errors.push('Le fichier doit être une image');
    }

    // Vérifier la taille (5MB max)
    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      errors.push('La taille de l\'image ne peut pas dépasser 5MB');
    }

    // Vérifier les formats supportés
    const supportedFormats = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    if (!supportedFormats.includes(file.type)) {
      errors.push('Formats supportés: JPEG, PNG, WebP');
    }

    return {
      isValid: errors.length === 0,
      errors
    };
  },

  // Redimensionner une image côté client (optionnel)
  resizeImage: (file, maxWidth = 1200, maxHeight = 900, quality = 0.8) => {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = () => {
        // Calculer les nouvelles dimensions
        let { width, height } = img;
        
        if (width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        }
        
        if (height > maxHeight) {
          width = (width * maxHeight) / height;
          height = maxHeight;
        }

        // Redimensionner
        canvas.width = width;
        canvas.height = height;
        
        ctx.drawImage(img, 0, 0, width, height);
        
        canvas.toBlob(resolve, 'image/jpeg', quality);
      };

      img.src = URL.createObjectURL(file);
    });
  }
};

export default photoService;